import { RadioGroup } from '@cimplico/components';

import PlanCard from './PlanCard';
import { Slider } from '../../../../components/Slider';
import { SubscriptionInterval, SubscriptionV2 } from '../../../../types/firm';
import { calculatePlan, formatCost, STEP } from './utils';
import { useMemo } from 'react';
import plans from './plans.json';

type PlanConfigurationProps = {
    subscription: SubscriptionV2;
    interval: string;
    activeEntities: number;
    setInterval: (interval: string) => void;
    setActiveEntities: (activeEntities: number) => void;
    readOnly?: boolean;
};

function PlanConfiguration({
    interval,
    activeEntities,
    setInterval,
    setActiveEntities,
    readOnly = false,
}: PlanConfigurationProps): JSX.Element {
    const plan = useMemo(() => calculatePlan(activeEntities), [activeEntities]);

    return (
        <>
            <div className={`flex items-start justify-between mt-8`}>
                <div>
                    <p className="text-sm font-bold text-contentPrimary mb-1">Billing Interval</p>
                    <RadioGroup
                        groupName="interval"
                        orientation="horizontal"
                        options={[
                            { label: 'Monthly', value: 'MONTHLY' },
                            { label: 'Yearly', value: 'YEARLY' },
                        ]}
                        value={interval}
                        onChange={(e): void => setInterval(e.target.value)}
                        disabled={readOnly}
                    />
                </div>
                <p className="text-2xl font-bold text-contentPrimary text-right w-full">
                    {formatCost(interval as SubscriptionInterval, activeEntities, plan)}
                    <span className="text-sm font-normal text-contentSecondary">/{interval === 'MONTHLY' ? 'month' : 'year'}</span>
                </p>
            </div>
            <p className="text-sm font-bold text-contentPrimary mt-4">Active Entities</p>
            <Slider
                value={[activeEntities]}
                max={3000}
                min={STEP}
                step={STEP}
                className="w-full mb-8 mt-8"
                onValueChange={(v): void => setActiveEntities(v[0])}
                disabled={readOnly}
            />
            <div className="grid grid-cols-4 gap-4">
                {Object.entries(plans).map(([_, p]) => (
                    <PlanCard
                        key={p.name}
                        name={p.name}
                        price={p.price}
                        includedEntities={p.includedEntities}
                        additionalEntitiesCost={p.additionalEntitiesCost}
                        isActive={plan.name === p.name}
                        onClick={(): void => setActiveEntities(p.includedEntities)}
                        disabled={readOnly}
                    />
                ))}
            </div>
        </>
    );
}

export default PlanConfiguration;
